// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"581e7d68","787":"41860650"}[chunkId] + ".chunk.js";
};